/**
 * For a chain of steps after a request made through an async model: the model says why a request failed (its own
 * error toast) and resolves with nothing, so a `.then` after it ran as if it had gone through -- an approval refused
 * by the service still said "Bill is successfully approved" (LB-5952).
 */
export const REQUEST_REFUSED = new Error('The request did not go through; it has said why.');

/**
 * Passes a request's answer on, and stops the chain when it failed: no answer, and the model recorded why. One with no
 * answer and no error was cancelled by a newer run of the same model, and goes on as it always did.
 * @param asyncModel the model the request was made through
 */
export const succeeded = asyncModel => resp => {
  if (!resp && asyncModel !== null && asyncModel !== void 0 && asyncModel.error) throw REQUEST_REFUSED;
  return resp;
};

/** Ends a chain quietly for a refused request, which has said why already; anything else goes on as before. */
export const unlessRefused = handle => error => {
  if (error === REQUEST_REFUSED) return undefined;
  return handle(error);
};